import keyBy from 'lodash.keyby';
import { call, select, put, all, fork } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import { AxiosResponse, AxiosError } from 'axios';

import { takeLatestWithCancel } from 'utils/redux-saga';
import axiosPoll from 'utils/axiosPoll';
import { selectLoadSprayedEntitiesParams } from './params';
import {
    setSprayedEntitiesByDate,
    succeededLoadSprayedEntitiesByDate,
    failedLoadSprayedEntitiesByDate
} from './actions';
import {
    SPRAYED_ENTITIES_BY_DATE_LOAD_REQUESTED,
    SPRAYED_ENTITIES_BY_DATE_LOAD_CANCELED
} from './constants';
import { RequestedLoadSprayedEntitiesByDateAction } from './types';

// Environment
const { REACT_APP_API_URL } = process.env;

export function* loadSprayedEntities(
    action: RequestedLoadSprayedEntitiesByDateAction
): SagaIterator {
    const { payload } = action;

    // Select params
    const params = yield select(selectLoadSprayedEntitiesParams, {
        startDate: payload
    });

    yield call(axiosPoll, {
        config: {
            method: 'GET',
            url: `${REACT_APP_API_URL}/v1/Entities`,
            params
        },
        succeeded: loadSprayedEntitiesSucceded,
        failed: loadSprayedEntitiesFailed
    });
}

export function* loadSprayedEntitiesSucceded(
    response: AxiosResponse
): SagaIterator {
    const { data } = response;
    const sprayEventsKeyedByIds = keyBy(data, 'id');

    yield put(setSprayedEntitiesByDate(sprayEventsKeyedByIds));

    yield put(succeededLoadSprayedEntitiesByDate(response));
}

export function* loadSprayedEntitiesFailed(error: AxiosError): SagaIterator {
    yield put(failedLoadSprayedEntitiesByDate(error));
}

export function* watchSprayedEntitiesLoadRequested(): SagaIterator {
    yield takeLatestWithCancel(
        SPRAYED_ENTITIES_BY_DATE_LOAD_REQUESTED,
        SPRAYED_ENTITIES_BY_DATE_LOAD_CANCELED,
        loadSprayedEntities
    );
}

export default function* sprayEventSprayedEntitiesSagas(): SagaIterator {
    yield all([fork(watchSprayedEntitiesLoadRequested)]);
}
